import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ShoppingCart, Heart } from 'lucide-react';

const ProductCard = ({ product, onAddToCart, compact = false }) => {
  const hasDiscount = product.old_price && product.old_price > product.price;
  const discountPercent = hasDiscount
    ? Math.round(((product.old_price - product.price) / product.old_price) * 100)
    : 0;

  return (
    <Link
      to={`/products/${product.id}`}
      className="group product-card bg-white border border-border rounded-sm overflow-hidden flex flex-col h-full relative"
      data-testid={`product-card-${product.id}`}
    >
      {/* Badges */}
      <div className="absolute top-2 left-2 z-10 flex flex-col gap-1">
        {hasDiscount && (
          <span className="bg-destructive text-white text-xs font-bold px-2 py-1 rounded-sm">
            -{discountPercent}%
          </span>
        )}
        {product.is_new && (
          <span className="bg-brand-orange text-white text-xs font-bold px-2 py-1 rounded-sm">
            NOUVEAU
          </span>
        )}
        {product.featured && !product.is_new && (
          <span className="bg-brand-dark text-white text-xs font-bold px-2 py-1 rounded-sm">
            TOP VENTE
          </span>
        )}
      </div>

      {/* Image */}
      <div className="aspect-square bg-surface overflow-hidden">
        <img
          src={product.images?.[0]}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Info */}
      <div className="p-3 md:p-4 flex flex-col flex-1">
        {product.brand && (
          <span className="text-xs text-muted-foreground uppercase tracking-wide mb-1">
            {product.brand}
          </span>
        )}
        <h3 className={`font-semibold text-foreground line-clamp-2 mb-2 group-hover:text-brand-orange transition-colors ${compact ? 'text-sm' : ''}`}>
          {product.name}
        </h3>

        <div className="flex items-center gap-1 mb-2">
          <Star className="w-4 h-4 fill-brand-orange text-brand-orange" />
          <span className="text-sm font-medium">{product.rating}</span>
          <span className="text-xs text-muted-foreground">({product.reviews_count})</span>
        </div>

        <div className="mt-auto">
          <div className="flex items-baseline gap-2">
            <span className="text-xl font-bold text-brand-orange">
              {product.price.toFixed(2)} €
            </span>
            {hasDiscount && (
              <span className="text-sm text-muted-foreground line-through">
                {product.old_price.toFixed(2)} €
              </span>
            )}
          </div>
          {product.stock > 0 ? (
            <span className="text-xs text-success font-medium">En stock</span>
          ) : (
            <span className="text-xs text-destructive font-medium">Rupture</span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
